<template>
  <v-app class="page">
    <Header :headTitle="headTitle" :isShowBackBtn="isShowBackBtn" :isShowLoginBtn="true" @clickUserInfo="userInfo"
      @clickLogOut="logout" @clickLogIn="logIn" @clickBack="clickBack" />
    <component :class="{ test: isTest }" :is="getThemeMode.layout" />

    <!-- userDrawer -->
    <v-navigation-drawer v-model="userDrawer" fixed right height="100%" temporary floating width="70%">
      <user-drawer :PropsAccessInfo="accessInfo" @closeDrawer="userDrawer = false" @clickHome="clickHome"
        @clickChangeUserInfo="clickChangeUserInfo" @clickChangePassword="clickChangePassword">
        <template v-slot:userDrawerCloseButton>
          <v-btn icon color @click.stop="userDrawer = !userDrawer">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </user-drawer>

      <template v-slot:append>
        <div class="my-4 mx-4">
          <base-hover-button text="로그아웃" color="primary" x-large depressed block @click.native="logout" />
        </div>
      </template>
    </v-navigation-drawer>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from "./commonComp/Header.vue";
import Cookies from "js-cookie";
import ConfirmDialog from "@/_bayer/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    Header,
    ConfirmDialog,
    UserDrawer: () => import("@/components/common-drawer/UserDrawer.vue"),
  },
  data() {
    return {
      isTest: false,
      layoutName: "",
      userDrawer: false,
      headTitle: "팜파트너",
      isShowBackBtn: false,
      moveTarget: '',
    };
  },
  computed: {
    accessInfo() {
      if (!this.isAuthorized) return;
      const CookieName = process.env.VUE_APP_CookieName;
      return JSON.parse(Cookies.get(CookieName));
    },
    ...mapGetters(["isAuthorized", "getThemeMode"]),
  },
  mounted() {
    // 리로드 처리
    if (this.$route.fullPath === "/userInfo") this.clickChangeUserInfo();
    if (this.$route.fullPath === "/changePassword") this.clickChangePassword();
  },
  methods: {
    userInfo() {
      this.userDrawer = !this.userDrawer;
    },
    logIn() {
      this.gotoPage("/login");
    },
    logout() {
      this.signOut().then(() => {
        this.gotoPage("/login");
      });
    },
    clickHome() {
      this.moveTarget = "팜파트너";
      if (this.headTitle === "개인정보변경") {
        this.$refs.refConfirmDialog.open("개인정보 변경을 중단하고 이동하시겠습니까?");
        return;
      }
      if (this.headTitle === "비밀번호변경") {
        this.$refs.refConfirmDialog.open("비밀번호 변경을 중단하고 이동하시겠습니까?");
        return;
      }
      this.headTitle = "팜파트너";
      this.isShowBackBtn = true;

      this.gotoPage("/");
    },
    clickChangeUserInfo() {
      this.moveTarget = "개인정보변경";
      if (this.headTitle === "비밀번호변경") {
        this.$refs.refConfirmDialog.open("비밀번호 변경을 중단하고 이동하시겠습니까?");
        return;
      }
      this.headTitle = "개인정보변경";
      this.isShowBackBtn = true;
      this.gotoPage("/userInfo");
    },
    clickChangePassword() {
      this.moveTarget = "비밀번호변경";
      if (this.headTitle === "개인정보변경") {
        this.$refs.refConfirmDialog.open("개인정보 변경을 중단하고 이동하시겠습니까?");
        return;
      }
      this.headTitle = "비밀번호변경";
      this.isShowBackBtn = true;
      this.gotoPage("/changePassword");
    },
    clickPopupConfirm() {
      switch (this.moveTarget) {
        case "팜파트너":
          this.headTitle = "팜파트너";
          this.isShowBackBtn = true;
          this.gotoPage("/");
          break;
        case "개인정보변경":
          this.headTitle = "개인정보변경";
          this.isShowBackBtn = true;
          this.gotoPage("/userInfo");
          break;
        case "비밀번호변경":
          this.headTitle = "비밀번호변경";
          this.isShowBackBtn = true;
          this.gotoPage("/changePassword");
          break;
      }

    },
    clickBack() {
      this.gotoPage("/");
    },
    gotoPage(page) {
      if (page === "/") {
        this.headTitle = "팜파트너";
        this.isShowBackBtn = false;
      }
      this.$router.push({ path: page }).catch(() => { });
    },
    ...mapActions(["signOut", "changeThemeLayout"]),
  },
};
</script>
<style lang="scss">
.page-header {
  position: relative;
  margin-bottom: 1rem;
  padding: 1rem;
  text-align: center;
  background: $mid-green;
  color: #ffffff;
  border-radius: 0 0 20px 20px;

  .btn-back {
    position: absolute;
    left: 15px;
    top: 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
  }

  .page-title {
    color: #ffffff;
    font-size: 1.3rem;
    margin-bottom: 0;
  }

  .v-icon {
    color: #ffffff;
  }
}

.loginOut {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
}
</style>
